export default "__VITE_ASSET__BZMC2jmN__"